import Vue from 'vue'
import axios from 'axios';
import VueAxios from 'vue-axios';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.interceptors.request.use(function (config) {
    // console.log(config)
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

Vue.use(VueAxios, axios);
